import React from 'react';
import styles from './PublicSiteFooter.module.css';

interface PublicSiteFooterProps {
  projectName: string;
}

export const PublicSiteFooter: React.FC<PublicSiteFooterProps> = ({ projectName }) => {
  const year = new Date().getFullYear();

  return (
    <footer className={styles.footer}>
      <div className={styles.container}>
        <span className={styles.brand}>{projectName}</span>
        <span className={styles.copy}>&copy; {year}. Alle rechten voorbehouden.</span>
      </div>
    </footer>
  );
};
